import React, { useState } from 'react';
import { Button, OverlayTrigger, Tooltip, Spinner } from 'react-bootstrap';
import StatusBar from '@components/StatusBar';
import { DialogConfirmation } from '@components/atomic/molecules';
import { IcoSendMail } from '@icons';
import { runRegisWorkflow } from '@lib/api';
import { translate } from 'components/translation/translation';
import { OETrans } from 'components/translation/OETrans';

const SendDataRegis = ({ projectId, isRegisProject, dataId, statementTypeCode, statementState }) => {
	const [showModalRegis, setShowModalRegis] = useState(false);
	const [isLoadingRegis, setIsLoadingRegis] = useState(false);
	const [sbShowRegis, setSbShowRegis] = useState(<></>);

	const handleShowModal = (setShowModal) => setShowModal(true);

	const handleStatusBar = (status, message, timeout, setSb = setSbShowRegis) => {
		setSb(<StatusBar status={status} message={message} timeout={timeout} />);
	};

	const handleDownload = async () => {
		setSbShowRegis(<></>);
		setIsLoadingRegis(true);

		runRegisWorkflow(projectId, dataId ?? null)
			.then((result) => {
				if (result.success) {
					handleStatusBar('success', translate('common.success.save', 'Le informazioni sono state salvate con successo'), true);

					handleShowModal(setShowModalRegis);
				}
			})
			.catch((error) => {
				handleStatusBar(
					'error',
					error.message ?? translate('common.error.save', "Si è verificato un errore durante l'elaborazione delle informazioni"),
					false,
					setSbShowRegis,
				);
			})
			.finally(() => {
				setIsLoadingRegis(false);
			});
	};

	const regisTooltip = (props) => {
		let message = '';

		if (isLoadingRegis) {
			message = <OETrans code="common.tooltip.downloading" fallback={'Download in corso...'} />;
		} else if (dataId) {
			let isDisabled = isRegisProject && statementTypeCode === 'ADV' && statementState === 'VALIDATED';

			if (isDisabled) {
				message = (
					<OETrans code="common.tooltip.disabled.downloadreportregis" fallback={'Non è disponibile per questo tipo di rendiconto'} />
				);
			} else {
				message = <OETrans code="common.tooltip.downloadreportregis" fallback={'Invia dati al ReGiS'} />;
			}
		} else {
			message = <OETrans code="common.tooltip.downloadallreportregis" fallback={'Invio massivo al ReGiS'} />;
		}

		return <Tooltip {...props}>{message}</Tooltip>;
	};

	return (
		<>
			{isRegisProject ? (
				<OverlayTrigger placement="top" overlay={regisTooltip}>
					<span>
						<Button
							variant="link"
							disabled={isRegisProject && dataId && statementTypeCode === 'ADV' && statementState === 'VALIDATED'}
							className={dataId ? 'me-3' : ''}
							onClick={() => handleShowModal(setShowModalRegis)}
						>
							{isLoadingRegis ? (
								<Spinner
									as="span"
									style={{ width: '25px', height: '25px' }}
									animation="border"
									role="status"
									aria-hidden="true"
									className="align-bottom"
								/>
							) : (
								<IcoSendMail className="second-color ico-small massive-upload align-bottom" />
							)}
						</Button>
					</span>
				</OverlayTrigger>
			) : null}

			<DialogConfirmation
				title={translate('common.warning', 'Attenzione')}
				content={
					<>
						<OETrans
							code="common.warning.regis.text1"
							fallback={'Stai per attivare la funzione di interoperabilità con il portale ReGiS.'}
						/>
						<br />
						<OETrans
							code="common.warning.regis.text2"
							fallback={'Questa operazione consente al sistema di scambiare dati con altri applicativi secondo i criteri definiti.'}
						/>
						<br />
						<br />
						<b>
							<OETrans code="common.warning" fallback={'Attenzione'} />:
						</b>
						&nbsp;
						<OETrans
							code="common.warning.regis.text3"
							fallback={"l'attivazione è un'operazione definitiva, non modificabile né annullabile."}
						/>
						&nbsp;
						<OETrans code="common.regis.text4" fallback={'Assicurati di aver verificato tutte le informazioni prima di procedere.'} />
						<br />
						<br />
						<b>
							<OETrans code="common.warning.wantproceed" fallback={'Sei sicuro di voler procedere?'} />
						</b>
					</>
				}
				confirmLabel={
					<>
						{translate('common.confirm', 'Conferma')}
						{isLoadingRegis && <Spinner as="span" animation="border" size="sm" className="ms-2" />}
					</>
				}
				typeConfirm="primary"
				cancelLabel={translate('common.cancel', 'Annulla')}
				onConfirm={() => handleDownload()}
				onCancel={() => {
					setShowModalRegis(false);
					setSbShowRegis(<></>);
				}}
				show={showModalRegis}
				onHide={() => {
					setShowModalRegis(false);
					setSbShowRegis(<></>);
				}}
				sbShow={sbShowRegis}
			/>
		</>
	);
};
export default SendDataRegis;
